var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardMySummaryBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_294_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 965.8 116",
    style: {
      enableBackground: "new 0 0 965.8 116"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.4;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st1{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.5416,
    y1: 208.5029,
    x2: 434.4816,
    y2: 210.6829,
    gradientTransform: "matrix(512.18 0 0 116 -221341.7656 -24201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20C5A0",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#0AB3D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02ACEC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0v116c10.2,0,6.8,0,15.3,0h950.5V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0v116c9.3,0,9.3,0,15.3,0h950.5V0H0z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M701.6,0c-77.1,39.2-154.2,34.3-219.2,28.4c-74.9-6.8-162.1,6.6-254.4,49.4C102.4,136.2,0,80.6,0,80.6V116 h964.7V0H701.6L701.6,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMySummaryBg);
export default __webpack_public_path__ + "static/media/DashboardMySummaryBG.94df52e59ae6c92b31325fc7136f0816.svg";
export { ForwardRef as ReactComponent };